import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./rankingPeso.module.scss";

export default function RankingPeso() {
    type Usuario = {
        id: number;
        nome: string;
        pesoInicial: number;
        pesoAtual: number;
        percentual?: number;
    };

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [ranking, setRanking] = useState<Usuario[]>([]);
    const [nome, setNome] = useState("");
    const [pesoInicial, setPesoInicial] = useState("");
    const [pesoAtual, setPesoAtual] = useState("");

    const adicionarUsuario = () => {
        if (!nome || !pesoInicial || !pesoAtual) return;
        const novo = {
            id: Date.now(),
            nome,
            pesoInicial: parseFloat(pesoInicial),
            pesoAtual: parseFloat(pesoAtual),
        };
        setUsuarios([...usuarios, novo]);
        setNome("");
        setPesoInicial("");
        setPesoAtual("");
        setRanking([]); // reset ranking ao adicionar novo
    };

    const gerarClassificacao = () => {
        const classificados = usuarios
            .map((u) => ({
                ...u,
                percentual:
                    ((u.pesoInicial - u.pesoAtual) / u.pesoInicial) * 100,
            }))
            .sort((a, b) => b.percentual - a.percentual);
        setRanking(classificados);
    };

    const getBadge = (index: number) => {
        switch (index) {
            case 0:
                return "🥇 1º";
            case 1:
                return "🥈 2º";
            case 2:
                return "🥉 3º";
            case 3:
                return "⭐ 4º";
            default:
                return `${index + 1}º`;
        }
    };

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Desafio de Perda de Peso</h1>

            {/* Formulário */}
            <div className={styles.card}>
                <input
                    type="text"
                    placeholder="Nome"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    className={styles.input}
                />
                <input
                    type="number"
                    placeholder="Peso inicial"
                    value={pesoInicial}
                    onChange={(e) => setPesoInicial(e.target.value)}
                    className={styles.input}
                />
                <input
                    type="number"
                    placeholder="Peso atual"
                    value={pesoAtual}
                    onChange={(e) => setPesoAtual(e.target.value)}
                    className={styles.input}
                />
                <button onClick={adicionarUsuario} className={styles.btnAdd}>
                    Adicionar
                </button>
            </div>

            {/* Lista de usuários */}
            {usuarios.length > 0 && (
                <div className={styles.card}>
                    <h2 className={styles.subtitle}>Participantes</h2>
                    {usuarios.map((u) => (
                        <p key={u.id} className={styles.participant}>
                            {u.nome} ({u.pesoInicial}kg → {u.pesoAtual}kg)
                        </p>
                    ))}
                </div>
            )}

            {/* Botão gerar classificação */}
            {usuarios.length > 0 && (
                <button
                    onClick={gerarClassificacao}
                    className={styles.btnRanking}
                >
                    Gerar Classificação
                </button>
            )}

            {/* Ranking animado */}
            <div className={styles.ranking}>
                <AnimatePresence>
                    {ranking.map((u, index) => (
                        <motion.div
                            key={u.id}
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                            className={`${styles.rankItem} ${index === 0
                                ? styles.gold
                                : index === 1
                                    ? styles.silver
                                    : index === 2
                                        ? styles.bronze
                                        : index === 3
                                            ? styles.fourth
                                            : ""
                                }`}
                        >
                            <span>
                                {getBadge(index)} - {u.nome}
                            </span>
                            <span>{u.percentual != null ? u.percentual.toFixed(1) : "0"}%</span>
                        </motion.div>
                    ))}
                </AnimatePresence>
            </div>
        </div>
    );
}
